import axios from 'axios';
import { FormInputIcon } from 'lucide-react';
import moment from 'moment';
import React, { useEffect, useState } from 'react';

const ProcessingVideo = ({ serverInfo }) => {
    const [items, setItems] = useState(null)
    const [grouped, setGrouped] = useState(null)
    const [selectGrouped, setSelectGrouped] = useState(null)
    const init = async () => {
        if (serverInfo) {
            const response = await axios.get("http://" + serverInfo.adresse + "/api/jobs?token=" + serverInfo.token)
            if (response?.data) {
                const jobs = response.data;
                if (Object.keys(jobs)?.length > 0) {
                    const jobsArray = Object.entries(jobs).map(([id, data]) => ({ id, ...data }));
                    const uniqueStatuses = [...new Set(jobsArray.map(job => job.status))];
                    const grouped = uniqueStatuses.map(status => {
                        const data = jobsArray
                            .filter(job => job.status === status)
                            .sort((a, b) => new Date(a.queuedAt) - new Date(b.queuedAt)); // plus vieux → plus récent

                        return { status, data };
                    });
                    setItems(jobsArray)
                    setGrouped(grouped)
                }
            }
        }
    }
    function formatDuration(ms) {
        if (ms == null) return "N/A";

        const totalSeconds = Math.floor(ms / 1000);

        if (totalSeconds < 60) {
            return `${totalSeconds} sec`;
        } else if (totalSeconds < 3600) {
            const minutes = Math.floor(totalSeconds / 60);
            const seconds = totalSeconds % 60;
            return `${minutes} min ${seconds} sec`;
        } else {
            const hours = Math.floor(totalSeconds / 3600);
            const minutes = Math.floor((totalSeconds % 3600) / 60);
            const seconds = totalSeconds % 60;
            return `${hours} h ${minutes} min ${seconds} sec`;
        }
    }

    function getTotalTimeHuman(job) {
        if (!job.queuedAt || !job.endTime) return "N/A";
        return formatDuration(new Date(job.endTime) - new Date(job.queuedAt));
    }

    function getUploadTimeHuman(job) {
        if (!job.startTime || !job.endTime) return "N/A";
        return formatDuration(new Date(job.endTime) - new Date(job.startTime));
    }
    const selectShowitem = () => {
        if (!selectGrouped && items) {
            return items
        } else if (selectGrouped) {
            return selectGrouped?.data
        }
    }
    useEffect(() => {
        init()
    }, [serverInfo])



    return (
        <div>
            <nav className='df gap1'>
                {grouped?.length > 0 && grouped.map((g, i) => (
                    <button onClick={() => setSelectGrouped(g)} key={i + "gr_id"} className='card carder cw df aic gap1'><FormInputIcon color='#fff' size={15} /> {g.status}</button>
                ))}
            </nav>
            <div className='df fdc gap1'>
                {selectShowitem()?.length > 0 && selectShowitem().map((item, i) => (
                    <div key={i + "_item_no_group"}>
                        <div className='df aic gap1'>
                            <p className='cw fr fs1'>{item.id}</p>
                            <p style={{ padding: "0.2em 0.4em" }} className={`${item.premium ? "bcyellow cb" : "bcb1 cw"} br5 fs1 fr `}>{item.premium ? "Premium" : "Normal"}</p>
                        </div>
                        <div className='df gap1 aic'>
                            <p style={{ padding: "0.2em 0.4em" }} className='bcw br5 fs1 fr cb'>{item.status}</p>
                            {item.progress && (
                                <p className='fr cw'>{item.progress}%</p>
                            )}
                            <p className='cw fr fs1'>Queue : {moment(item.queuedAt).format("DD/MM - HH:mm")}</p>
                            <p className='cw fr fs1'>Début : {moment(item.startTime).format("DD/MM - HH:mm")}</p>
                            {item.endTime && (
                                <>
                                    <p className='cs fr fs1'>Fin : {moment(item.endTime).format("DD/MM - HH:mm")}</p>
                                    <p style={{ padding: "0.2em 0.4em" }} className='bcs br5 fs1 fr cw'>Queue - Fin {getTotalTimeHuman(item)}</p>
                                    <p style={{ padding: "0.2em 0.4em" }} className='bcs br5 fs1 fr cw'>Upload - Fin {getUploadTimeHuman(item)}</p>
                                </>
                            )}


                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ProcessingVideo;